export const completionDisplayItemProvider = (monaco, measures, AGGREFATE_FUNCTIONS, props = {}, editorType) => {
  // Don't change the structure of this code. Else the functionality will break
  let { measureId } = props
  console.log(props)
  return {
    provideCompletionItems(model, position) {
      return {
        suggestions: [...AGGREFATE_FUNCTIONS.map(fun => {
          return {
            label: fun.name,
            insertText: fun.functionString,
            detail: fun.syntax,
            documentation: fun.description,
            kind: 0,
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet
          }
        }),
        ...measures.filter(msr => measureId !== msr._id).map(measure => {
          return {
            label: measure?.displayName ?? measure?.name,
            insertText: measure?.displayName ?? measure?.name,
            detail: measure.dataSetType,
            documentation: measure.dataSetType,
            kind: 18
          }
        })
        ]
      }
    }
  }
}